import { ISelectedCustomer, ISelectedCustomerV2 } from "../../pages/Customers/CustomerGroup/Component/EditGroup/EditGroup";
import { IVConditionFilterCampaim } from "../../pages/Marketing/AnnouncementCampaign/Create";
import axiosClient, { ResponseSuccess, ResponseSuccessTotal } from "../axiosClient";
import { ICustomer } from "../Customer_V2/customerApi_V2";
import { IConditionSync, IVConditionFilterADD } from "../groupCustomerV2/groupCustomerV2Api";

// export interface ICampaign {
//     id: number;
//     image: string;
//     title: string;
//     numberharacters: number;
//     expense: number;
//     numberPrefixs: string;
// }

export interface ICampaign {
  id: number
  title: string
  role: number
  type: number
  view: number
  status: number
  auto: number
  dateSend: string
  timeSend: string
  totalDeposit: number
  targetId: number
  targetTitle: string
  network: Network[]
  numberSend: string
  code?: string
  admin?: string
  creationDate?: string
}


export interface IAddCampainSucces {
  id: number
}

export interface Network {
  id: number
  title: string
  image: string
}

export interface ICampaignCosts {
  Email: ICostChanel[]
  SMS: ICostChanel[]
  ZNS: ICostChanel[]
  totalExpense: number
  totalChannelExpense: number
  totalZNSExpense: number
  totalSMSExpense: number
  totalEmailExpense: number
}

export interface ICostChanel {
  networkId: number
  networkTitle: string
  networkImage: string
  totalCustomers: number
  expense: number
}



export interface ICustomerReceived {
  title: string
  dataSend: DataSend[]
}

export interface DataSend {
  id: number
  status: number
  timeSend: string
  customerId: number
  customerName: string
}


export interface IICampaignDetail {
  id: number
  title: string
  code: string
  adminId: number
  targetId: number[]
  type: number
  role: number
  auto: number
  status: number
  dateSend: string
  timeSend: string
  channels: Channel[]
  groups?: IGroupCampaign[]
  // customers: Customer[]
  // totalCustomer: number
  // campaignCosts: ICampaignCosts
  listFilter: IVConditionFilterCampaim
  customerId?: ISelectedCustomerV2[]
  voucherId?: number
}

export interface Channel {
  channelId: number
  integrationProviderId: number
  notificationTemplateId: number
}

export interface Group {
  id: number
  title: string
  total: number
}

export interface Customer {
  id: number
  code: string
  name: string
  fields: Field[]
  groupPermissionId: number
  permissionMenu: PermissionMenu
}

export interface Field {
  fieldId: number
  fieldLabel: string
  fieldCode: string
  value: any
  view: boolean
}

export interface PermissionMenu {
  groupPermissionId: number
  view: boolean
  edit: boolean
  delete: boolean
}


export interface IChannelList {
  channelId: number
  integrationProviderId?: number
  notificationTemplateId: number
}




export interface IChannelListV9 {
  channelId: number
  brandId?: number
  notificationTemplateId?: number
  categoryId?: string
}


export interface IListCustomerByGroup {
  groups: IGroupCampaign[]
  customersFinal: ICustomer[]
}

export interface IGroupCampaign {
  id: number
  title?: string
  total?: number
}


export interface ILogCustomerOfCampaign {
  total: number
  totalSuccess: number
  totalFail: number
  dataList: ICustomer[]
}

//Danh sách chiến dịch
export const getListCampaign = async (
  limit?: number, pageNumber?: number, channelId?: number, auto?: number, search?: string
) => {
  const path = "campaign/listCampaign"
  const params = {
    limit, pageNumber, channelId, auto, keyword: search || undefined
  }
  const result: ResponseSuccessTotal<ICampaign[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

//Danh sách khách hàng nhận tin nhắn
export const getlistCustomerReceived = async (
  campaignId: number, limit?: number, pageNumber?: number, sortStatus?: number, dateStart?: string, dateEnd?: string
) => {
  const path = "campaign/listCustomerReceived"
  const params = {
    campaignId, limit, pageNumber, sortStatus, dateStart, dateEnd
  }
  const result: ResponseSuccessTotal<ICustomerReceived> = await axiosClient.get(
    path, { params }
  );
  return result;
};

//Thông tin chiến dịch
export const getInfoCampaign = async (
  id: number) => {
  const path = "campaign/infoCampaign"
  const params = {
    id
  }
  const result: ResponseSuccess<IICampaignDetail> = await axiosClient.get(
    path, { params }
  );
  return result;
};

//Danh sách khách hàng nhận tin nhắn theo kênh
export const getlistCampaignChannel = async (
  campaignId: number, notificationTemplateId: number, channelId: number
) => {
  const path = "campaign/listCampaignChannel"
  const params = {
    campaignId, notificationTemplateId, channelId
  }
  const result: ResponseSuccess<DataSend[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

//Chi phí diện dịch
export const getInfoCampaignCosts = async (
  customerId?: number[], groupCustomerId?: number[], channelList?: IChannelList[], sqlTotal?: string,
  campaignId?: number, voucherId?: number
) => {
  const path = "campaign/campaignCosts"
  const params = {
    customerId, groupCustomerId, channelList, sqlTotal,
    campaignId, voucherId
  }
  const result: ResponseSuccess<ICampaignCosts> = await axiosClient.post(
    path, params
  );
  return result;
};


//Thêm mới chiến dịch
export const addCampaign = async (
  title: string, adminId: number, targetId: number, channelList: IChannelListV9[],
  type: number, role: number, auto: number,
  // customerId?: ISelectedCustomer[], groups?: IGroupCampaign[], dateSend?: string, timeSend?: string,
  groups?: IGroupCampaign[], dateSend?: string, timeSend?: string,
  sendEvent?: number, sendInAdvance?: number, listFilter?: IVConditionFilterADD, description?: string,
  voucherId?: number
) => {
  const url = `campaign/addCampaign`;
  const params = {
    title, adminId, targetId, channelList,
    type, role, auto,
    groups, dateSend, timeSend,
    sendEvent, sendInAdvance, listFilter: JSON.stringify(listFilter), description,
    voucherId
  }
  const result: ResponseSuccess<IAddCampainSucces> = await axiosClient.post(
    url, params
  );
  return result;
}

export const addCustomerCampaign = async (
  campaignId: number,
  customerId?: ISelectedCustomer[]
) => {
  const url = `campaign/addCustomerCampaign`;
  const params = {
    campaignId,
    customerId
  }
  const result: ResponseSuccess<[]> = await axiosClient.post(
    url, params
  );
  return result;
}



//Chỉnh sửa chiến dịch
export const editCampaign = async (
  id: number, title: string, targetId: number, channelList: IChannelListV9[],
  type: number, role: number, auto: number, groups?: IGroupCampaign[], dateSend?: string, timeSend?: string,
  sendEvent?: number, sendInAdvance?: number, listFilter?: IVConditionFilterADD, description?: string,
  voucherId?: number
) => {
  const url = `campaign/editCampaign`;
  const params = {
    id, title, targetId, channelList,
    type, role, auto, groups, dateSend, timeSend,
    sendEvent, sendInAdvance, listFilter: JSON.stringify(listFilter), description,
    voucherId
  }
  const result: ResponseSuccess<[]> = await axiosClient.put(
    url, params
  );
  return result;
}

//Cập nhật trạng thái chiến dịch
export const activeCampaign = async (
  id: number
) => {
  const url = `campaign/activeCampaign`;
  const params = {
    id
  }
  const result: ResponseSuccess<[]> = await axiosClient.put(
    url, params
  );
  return result;
}

// gửi chiến dịch tưc thì
export const sendInstantlyCampaign = async (
  campaignId: number,
) => {
  const url = `campaign/sendInstantlyCampaign`;
  const params = {
    campaignId,
  }
  const result: ResponseSuccess<[]> = await axiosClient.post(
    url, params
  );
  return result;
}

//Xóa chiến dịch
export const deleteCampaign = async (
  id: Number
) => {
  const url = `campaign/deleteCampaign`;
  const params = {
    id
  }
  const result: ResponseSuccess<[]> = await axiosClient.delete(
    url, { params }
  );
  return result;
}


///campaign/listCustomersByGroups
export const getListCustomersByGroups = async (
  groupIds: number[],
  limit?: number, pageNumber?: number, unitId?: number, unitIds?: number[],
  categoryCarIds?: number[], search?: string, customerIds?: number[], campaignId?: number,
  voucherId?: number
) => {
  const path = "campaign/listCustomersByGroups"
  const params = {
    groupIds,
    limit, pageNumber, unitId, unitIds,
    categoryCarIds, search, customerIds, campaignId,
    voucherId
  }
  const result: ResponseSuccessTotal<IListCustomerByGroup> = await axiosClient.get(
    path, { params }
  );
  return result;
};

// /campaign/listCustomersRemainByGroups
export const getListCustomersUnmatchedByGroups = async (
  groupIds: number[],
  limit?: number, pageNumber?: number, unitId?: number, unitIds?: number[],
  categoryCarIds?: number[], search?: string, campaignId?: number
) => {
  const path = "campaign/listCustomersRemainByGroups"
  const params = {
    groupIds,
    limit, pageNumber, unitId, unitIds,
    categoryCarIds, search, campaignId
  }
  const result: ResponseSuccessTotal<ICustomer[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

// /campaign/listCustomerIdByGroupAndUser
export const getListALLCustomerIdByGroupAndUser = async (
  groupIds: number[],
  customerIds?: number[], campaignId?: number, voucherId?: number

) => {
  const path = "campaign/listCustomerIdByGroupAndUser"
  const params = {
    groupIds,
    customerIds, campaignId, voucherId
  }
  const result: ResponseSuccessTotal<ISelectedCustomer[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};


// log
export const getListLogCustomerOfCampaign = async (
  campaignId: number,
  limit?: number, lastId?: number

) => {
  const path = "campaign/listLogCustomerOfCampaign"
  const params = {
    campaignId,
    limit, lastId
  }
  const result: ResponseSuccess<ILogCustomerOfCampaign> = await axiosClient.get(
    path, { params }
  );
  return result;
};

//Chi phí diện dịch
export const resendCampaign = async (
  campaignId: number
) => {
  const path = "campaign/resendCampaign"
  const params = {
    campaignId
  }
  const result: ResponseSuccess<[]> = await axiosClient.post(
    path, params
  );
  return result;
};


